module.exports = __webpack_public_path__ + "img/mobile-catch-middle.117da94d.png";